/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {useEffect, useState} from 'react';
import {Accordion, Button} from 'react-bootstrap';
import CustomListGroupAction from 'components/Custom/ListGroup/CustomListGroupAction';

import type {ConditionObject, IPccRuleFormDynamic} from 'interfaces';
import {
	defaultRuleDynamicDataAction,
	defaultFlowInfoDataAction,
	labelActionsPccRule,
	transformLabelActions,
	resolveFieldRuleKey,
	setNestedField,
	getNestedField,
} from './utils/InitActionLabels';
import DynamicPccRuleForm from './DynamicPccRuleForm';

type TProps = {
	rowRule: IPccRuleFormDynamic;
	headerAccordion: string;
	typeForm: string;
	isVolTE: boolean;
	onObserver: (isValid: boolean) => void;
	onDeleteRuleDynamicId: (id: string) => void;
	onUpdateRule: (id: string, updatedRule: IPccRuleFormDynamic) => void;
};

const RuleActionForm = ({
	rowRule,
	headerAccordion,
	typeForm,
	isVolTE,
	onObserver,
	onDeleteRuleDynamicId,
	onUpdateRule,
}: TProps) => {
	const [rule, setRule] = useState<IPccRuleFormDynamic>(rowRule);

	useEffect(() => {
		onUpdateRule(rule.id, rule);
	}, [rule, onUpdateRule]);

	const handleFieldSelect = (id: string, ...path: string[]) => {
		const resetToDefault = (
			prevPccRule: IPccRuleFormDynamic,
			keys: string[],
		) => {
			const defaultData = defaultRuleDynamicDataAction();
			const defaultValue = getNestedField(defaultData, keys);
			if (defaultValue === undefined) return prevPccRule;
			return setNestedField(prevPccRule, keys, defaultValue);
		};

		setRule(prevPccRule => {
			if (prevPccRule.id !== id) return prevPccRule;

			const fieldNameConvert = resolveFieldRuleKey(...path);
			if (!fieldNameConvert) return prevPccRule;

			// Manejo generalizado para otras etiquetas complejas
			if (Array.isArray(fieldNameConvert)) {
				const [parentKey, ...nestedKeys] = fieldNameConvert;
				const currentField = getNestedField<ConditionObject<any>>(prevPccRule, [
					parentKey,
					...nestedKeys,
				]);

				if (!currentField) return prevPccRule;
				const isLeaf = currentField.active !== undefined;
				if (isLeaf) {
					// Comportamiento original para ConditionObject simple
					const updatedField = {
						...currentField,
						active: !currentField.active,
					};
					if (!updatedField.active) {
						return resetToDefault(prevPccRule, [parentKey, ...nestedKeys]);
					}
					return setNestedField(
						prevPccRule,
						[parentKey, ...nestedKeys],
						updatedField,
					);
				} else {
					const updatedField: Record<string, any> = {};
					let allInactive = true;

					for (const subKey of Object.keys(currentField)) {
						const child = (currentField as any)[subKey];
						if (child && typeof child === 'object' && 'active' in child) {
							const toggled = {...child, active: !child.active};
							updatedField[subKey] = toggled;
							if (toggled.active) allInactive = false;
						} else {
							updatedField[subKey] = child;
						}
					}

					if (allInactive) {
						return resetToDefault(prevPccRule, [parentKey, ...nestedKeys]);
					}

					return setNestedField(
						prevPccRule,
						[parentKey, ...nestedKeys],
						updatedField,
					);
				}
			}

			// Manejo para etiquetas simples
			if (fieldNameConvert in prevPccRule) {
				const currentField =
					prevPccRule[fieldNameConvert as keyof IPccRuleFormDynamic];

				if (path && path[0] === 'Flow Information') {
					return {
						...prevPccRule,
						[fieldNameConvert]: !currentField,
					};
				} else if (
					typeof currentField === 'object' &&
					currentField &&
					'active' in currentField
				) {
					const updatedField = {
						...currentField,
						active: !currentField.active,
					};
					if (!updatedField.active) {
						const keysToReset = [fieldNameConvert];

						return keysToReset.reduce(
							(updated, key) => resetToDefault(updated, [key]),
							prevPccRule,
						);
					}
					return {
						...prevPccRule,
						[fieldNameConvert]: updatedField,
					};
				}
			}
			return prevPccRule;
		});
	};

	const updateRuleData = (
		keyForm: string,
		path: string[],
		value: string,
		type: string,
		checked: boolean,
		key: number | string | null,
	) => {
		const valueField = type === 'checkbox' ? checked : value;

		const deepUpdate = (
			obj: any,
			tags: string[],
			valueArg: any,
			itemId?: string | number | null,
		): any => {
			if (tags.length === 0) return obj;

			const [current, ...rest] = tags;
			const next = obj?.[current];

			// Si es un array y tenemos una key por ID
			if (Array.isArray(next) && itemId !== null && rest.length > 0) {
				return {
					...obj,
					[current]: next.map((item: any) =>
						item.id === itemId ? deepUpdate(item, rest, valueArg, null) : item,
					),
				};
			}

			// Último nivel: actualizar .value dentro del objeto
			if (rest.length === 0) {
				if (typeof next === 'object' && next !== null) {
					return {
						...obj,
						[current]: {
							...next,
							value: valueArg,
						},
					};
				}
				return obj;
			}

			return {
				...obj,
				[current]: deepUpdate(next ?? {}, rest, valueArg, itemId),
			};
		};

		setRule(prevPccRule => {
			if (
				type === 'text' ||
				type === 'number' ||
				type === 'select-one' ||
				type === 'checkbox'
			) {
				return deepUpdate(prevPccRule, path, valueField, key);
			}
			return prevPccRule;
		});
	};

	const handleRemove = (tag: string, id: string) => {
		setRule(prevRule => {
			if (tag === 'flowInfo') {
				const updatedFlowInfo = prevRule.flowInfo.filter(
					item => item.id !== id,
				);

				return {
					...prevRule,
					flowInfo: updatedFlowInfo,
				};
			}
			return prevRule;
		});
	};

	const handleFlowInfoAdd = () => {
		setRule(prev => ({
			...prev,
			flowInfo: [...(prev.flowInfo || []), defaultFlowInfoDataAction()],
		}));
	};

	const handleRuleDynamicIdDelete = () => {
		onDeleteRuleDynamicId(rowRule.id);
	};

	return (
		<Accordion className="accordion-nested">
			<Accordion.Item
				eventKey={rowRule.id}
				key={rowRule.id}
				className="rounded border">
				<Accordion.Header className="position-relative">
					{headerAccordion}
					<Button
						onClick={() => handleRuleDynamicIdDelete()}
						type="button"
						variant="secondary"
						className="border-0 bg-transparent btn-sm ml-2 d-inline position-absolute z-index top-0 end-0 pr-2 pt-3">
						<span className="btn-label">
							<i className="bi-1 bi-trash3-fill invalid-color" />
						</span>
					</Button>
				</Accordion.Header>
				<Accordion.Body className="newBox &gt; px-0">
					<div
						className="container-fluid &gt; px-0"
						style={{height: '70vh', overflow: 'hidden'}}>
						{/* Intro */}
						<div className="rounded-3 mb-4 px-4" style={{height: '100%'}}>
							<div className="row" style={{height: '100%'}}>
								<div className="col-12 col-lg-6 col-xl-5">
									{/* list possible conditions */}
									<div className="row">
										<div className="col-12">
											<CustomListGroupAction
												options={transformLabelActions(
													labelActionsPccRule,
													typeForm as 'App' | 'Gw',
													isVolTE,
												)}
												formData={rule}
												onSelect={handleFieldSelect}
												resolveKey={resolveFieldRuleKey}
												nameDropdown={'Labels enabled'}
											/>
										</div>
									</div>
								</div>
								<div
									className="col-12 col-lg-6 col-xl-7"
									style={{height: '100%'}}>
									<div className="row" style={{height: '100%'}}>
										<div className="col-12" style={{height: '100%'}}>
											<DynamicPccRuleForm
												formData={rule}
												updateRuleData={updateRuleData}
												onObserver={onObserver}
												onAddFlowInfo={handleFlowInfoAdd}
												onDeleteFlowInfo={handleRemove}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
};

export default RuleActionForm;
